import React, { useState } from "react";
import styles from "../css/styles.module.css";
import Select from "react-select";
import { selectStyle } from "./selectStyle";

export default function EditContact(props) {
  const [contact, setContact] = useState({
    name: props.contact.data.name,
    customer: props.contact.data.customer,
    phone: props.contact.data.phone,
    position: props.contact.data.position,
    email: props.contact.data.email
  });

  function handleChange(e) {
    setContact({
      ...contact,
      [e.target.name]: e.target.value,
    });
  }

  //handle dropdow select change
  function handleSelectChange(selected, actionMeta) {
    setContact({
      ...contact,
      [actionMeta.name]: selected.value,
    });
  }

  return (
    <div className={styles.form}>
      <form onSubmit={(e) => props.handleEditSubmit(e, contact)}>
        <h1>Edit Contact</h1>
        <Select
          name="customer"
          defaultValue={{
            label: contact.customer,
            value: contact.customer
          }}
          styles={selectStyle}
          isSearchable
          options={props.customer}
          onChange={(selected, actionMeta) =>
            handleSelectChange(selected, actionMeta)
          }
        />
        <input
          type="text"
          name="name"
          value={contact.name}
          onChange={(e) => handleChange(e)}
          required
        />
        <input
          type="text"
          name="email"
          value={contact.email}
          onChange={(e) => handleChange(e)}
        />
        <input
          type="text"
          name="phone"
          value={contact.phone}
          onChange={(e) => handleChange(e)}
        />
        <input
          type="text"
          name="position"
          value={contact.position}
          onChange={(e) => handleChange(e)}
        />
        <button type="submit">Edit</button>
      </form>
      <button className={styles.cancelButton} onClick={props.handleCancelClick}>
        Cancel
      </button>
    </div>
  );
}
